import { render, staticRenderFns } from "./RoomView.vue?vue&type=template&id=38adf0ac&scoped=true"
import script from "./RoomView.vue?vue&type=script&lang=js"
export * from "./RoomView.vue?vue&type=script&lang=js"
import style0 from "./RoomView.vue?vue&type=style&index=0&id=38adf0ac&prod&scoped=true&lang=css"
import style1 from "./RoomView.vue?vue&type=style&index=1&id=38adf0ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38adf0ac",
  null
  
)

export default component.exports